import { render } from "./Chapter10.vue?vue&type=template&id=0f5f171a"
import script from "./Chapter10.vue?vue&type=script&lang=js"
export * from "./Chapter10.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__